import { render } from "./StarsBackground.vue?vue&type=template&id=218371bb"
const script = {}

import "./StarsBackground.vue?vue&type=style&index=0&id=218371bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__